import { Eye, EyeOff } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { usePageVisibility } from "@/hooks/usePageVisibility";

interface PageVisibilityToggleProps {
  pageKey: string;
  label: string;
}

export function PageVisibilityToggle({ pageKey, label }: PageVisibilityToggleProps) {
  const { isVisible, setVisible, isUpdating } = usePageVisibility();
  const visible = isVisible(pageKey);

  return (
    <div
      className={`flex items-center justify-between px-4 py-3 rounded-xl border transition-all ${
        visible
          ? "bg-emerald-50 border-emerald-200"
          : "bg-gray-50 border-gray-200"
      }`}
    >
      <div className="flex items-center gap-3 min-w-0">
        <div
          className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
            visible ? "bg-emerald-100" : "bg-gray-100"
          }`}
        >
          {visible ? (
            <Eye className="w-4 h-4 text-emerald-600" />
          ) : (
            <EyeOff className="w-4 h-4 text-gray-400" />
          )}
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-gray-800 truncate">{label}</p>
          <p className={`text-xs ${visible ? "text-emerald-600" : "text-gray-400"}`}>
            {visible ? "Visível no site público" : "Oculto do site público"}
          </p>
        </div>
      </div>

      <Switch
        checked={visible}
        onCheckedChange={(v) => setVisible(pageKey, v)}
        disabled={isUpdating}
        className="shrink-0"
      />
    </div>
  );
}
